import styled from "styled-components";

export const DiscardTableDetailChangesStyled = styled.div`
  .discard-info-text {
    padding: 38px 66px 71px 35px;
    font-size: 17px;
    color: ${({ theme }): string => theme.textColors.BLACK_COLOR};
  }
`;
